import httpClient from "../http/http-client";

export default class ConversionSourceYearService {
  http;
  constructor() {
    this.http = httpClient
  }

  async update(conversionSourceId: string, data: any): Promise<void> {
    return this.http.patch(`conversion-source-year/${conversionSourceId}`, data)
      .then(response => {
        return response.data
      })
      .catch(err => {
        throw err
      });
  }

  async getYearUsage(conversionSourceId: string, year: string): Promise<{ conversionSourceId: string, year: string, anchoredCalculationCount: number }> {
    return this.http.get(`conversion-source-year/${conversionSourceId}/usage?year=${encodeURIComponent(year)}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        throw err
      });
  }
}